module.exports = __webpack_public_path__ + "static/media/elev-02.05eadd40.svg";